    export async function fileToBase64( file: File ): Promise<string> {
        return new Promise( ( resolve, reject ) => {
            const reader = new FileReader();
            reader.onload = () => {
                // remove the data:image prefix so we can decode on server
                const regex = /^data:image\/[a-zA-Z]+;base64,/;
                resolve( ( reader.result as string ).replace( regex, '' ) );
            }
            reader.onerror = ( error ) => reject( error );
            reader.readAsDataURL( file );
        } );
    }